// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"679":"34242bd2","995":"34242bd2","1970":"34242bd2","3105":"34242bd2","3497":"34242bd2","5334":"34242bd2","8107":"34242bd2","9328":"34242bd2"}[chunkId] + ".chunk.css";
};